import React, {Suspense, lazy, useState} from "react";
import {buildStyles} from "connectui/component/buildStyles";
import {useTheme} from "connectui/theme/ThemeProvider";
import Container from "connectui/component/layout/Container";
import Drawer from "connectui/component/modal/Drawer";
import ButtonIcon from "connectui/component/input/button/ButtonIcon";
import SvgIcon from "connectui/component/display/SvgIcon";
import ICONS from "connectui/icons/iconMap";
import Text from "connectui/component/display/Text";
import ButtonText from "connectui/component/input/button/ButtonText";
import FilledTextField from "core/inputs/FilledTextField";
import FlexContainer from "connectui/component/layout/FlexContainer";

const useStyles = (theme) =>
  buildStyles({
    outerContainer: {
      width: "100%",
      height: "100%",
      background: theme.colors.white,
      display: "flex",
      flexDirection: "column",
    },
  });

const WhatsappDrawer = ({open, setOpen, selectedTemplate, saveTemplate}) => {
  const {theme} = useTheme();
  const classes = useStyles(theme);
  const [template, setTemplate] = React.useState(
    selectedTemplate || {components: [{text: "", type: "BODY", paired: true}]},
  );
  let templateBody = template?.components?.[0]?.text;
  const allowSave = !!templateBody && !!template?.name;
  function editTemplate(field, val) {
    setTemplate({...template, [field]: val});
  }

  React.useEffect(() => {
    setTemplate(
      selectedTemplate || {
        components: [{text: "", type: "BODY", paired: true}],
      },
    );
  }, [selectedTemplate]);

  return (
    <Drawer
      isOpen={["edit_template", "create_template"].includes(open)}
      onClose={() => setOpen(false)}
      position="right"
      style={{maxWidth: 700}}
    >
      <FlexContainer
        flexDirection="column"
        gap={theme.spacing(5)}
        style={{padding: theme.spacing(5), minWidth: "500px"}}
        alignItems={"flex-start"}
        justifyContent={"center"}
      >
        <Text variant="displayXS" weight="semibold">
          {open === "edit_template" ? "View Template" : "Create Template"}
        </Text>
        <Container style={{height: theme.spacing(5)}} />
        <FilledTextField
          placeholder="Name of template..."
          value={template?.name}
          onChange={(e) => editTemplate("name", e.target.value)}
          label={"Template name"}
          fullWidth
        />
        <Container style={{height: theme.spacing(5)}} />
        <FilledTextField
          placeholder="Please enter your template content..."
          value={templateBody}
          onChange={(e) =>
            editTemplate("components", [
              {...template.components[0], text: e.target.value},
            ])
          }
          label={"Template body"}
          useCustomFields
          multiline
          fullWidth
        />
        {open !== "edit_template" && (
          <ButtonText
            label={"Save"}
            disabled={!allowSave}
            color="white"
            style={{width: "100%"}}
            typographyVariant="textSM"
            weight="semibold"
            onClick={() => saveTemplate(template)}
          />
        )}
      </FlexContainer>
    </Drawer>
  );
};

export default WhatsappDrawer;
